/**
 * @generated SignedSource<<2067aff7e631c353ce503750894002fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedLocationItems_componentModule$data = {
  readonly cmsDisplayTitle: string | null;
  readonly " $fragmentType": "HpSharedLocationItems_componentModule";
};
export type HpSharedLocationItems_componentModule$key = {
  readonly " $data"?: HpSharedLocationItems_componentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedLocationItems_componentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedLocationItems_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cmsDisplayTitle",
      "storageKey": null
    }
  ],
  "type": "LocationsModule",
  "abstractKey": null
};

(node as any).hash = "20b78714a274b781cf9891da2554af05";

export default node;
